export default __webpack_public_path__ + "static/media/noProductImg.f5d56877.png";